"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.deliveryPointReducerFunction = exports.deliveryPointActions = exports.DeliveryPointState = exports.initialState = void 0;
var immer_reducer_1 = require("immer-reducer");
var buildOrderAlertsData_1 = require("../helper/buildOrderAlertsData");
exports.initialState = {
    clientWorkOrders: {
        data: [],
        loading: false
    },
    clientWorkOrdersV2: {
        data: null,
        loading: false
    },
    deliveryPoints: {
        data: [],
        loading: false
    },
    currentDeliveryPoint: {
        data: null,
        loading: false
    },
    combinedDeliveryPoint: {
        data: null,
        loading: false
    },
    overConsumptionsAlerts: {
        data: [],
        loading: false
    },
    alerts: {
        data: null,
        orderedData: null,
        loading: false,
        success: null
    },
    updateResidualLeakStatus: {
        loading: false,
        errorMessage: null,
        success: null
    },
    updateTranquilityStatus: {
        loading: false,
        errorMessage: null,
        success: null
    },
    updateOverconsumptionThreshold: {
        loading: false,
        errorMessage: null,
        success: null
    },
    meterInfo: {
        data: null,
        loading: false
    },
    meterIndex: {
        data: null,
        loading: false,
        isSanitationOnly: false,
        success: null
    },
    sendingMeterIndex: {
        isSend: false,
        loading: false
    },
    downloadDocument: {
        loaded: false,
        downloadErrorMsg: null,
        downloadLoading: false,
        errorStatus: null,
        proofDocument: null
    },
    requestsTracking: {
        loading: false,
        success: false,
        errorMsg: null,
        data: null
    },
    sendingMeterIndexEligibility: {
        sendingMeterIndexEligibility: null,
        loading: false,
        errorMessage: null,
        success: null
    }
};
var DeliveryPointState = /** @class */ (function (_super) {
    __extends(DeliveryPointState, _super);
    function DeliveryPointState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeliveryPointState.prototype.reset = function () {
        this.draftState = exports.initialState;
    };
    DeliveryPointState.prototype.fetchClientWorkOrder = function (deliverypointid) {
        this.draftState.clientWorkOrders.loading = true;
        this.draftState.clientWorkOrders.errorMessage = undefined;
    };
    DeliveryPointState.prototype.fetchClientWorkOrderSuccess = function (ClientWorkOrder) {
        this.draftState.clientWorkOrders.loading = false;
        this.draftState.clientWorkOrders.data = ClientWorkOrder;
    };
    DeliveryPointState.prototype.fetchClientWorkOrderFailure = function (errorMsg) {
        this.draftState.clientWorkOrders.loading = false;
        this.draftState.clientWorkOrders.errorMessage = errorMsg;
    };
    //Fetch client work order v2
    DeliveryPointState.prototype.fetchClientWorkOrderV2 = function (deliverypointid) {
        this.draftState.clientWorkOrdersV2.loading = true;
        this.draftState.clientWorkOrdersV2.errorMessage = undefined;
    };
    DeliveryPointState.prototype.fetchClientWorkOrderSuccessV2 = function (ClientWorkOrder) {
        this.draftState.clientWorkOrdersV2.loading = false;
        this.draftState.clientWorkOrdersV2.data = ClientWorkOrder;
        this.draftState.clientWorkOrdersV2.errorMessage = undefined;
    };
    DeliveryPointState.prototype.fetchClientWorkOrderFailureV2 = function (errorMsg) {
        this.draftState.clientWorkOrdersV2.loading = false;
        this.draftState.clientWorkOrdersV2.errorMessage = errorMsg;
        this.draftState.clientWorkOrdersV2.data = null;
    };
    //fetch delivery point by its id
    DeliveryPointState.prototype.fetchDeliveryPoint = function (sectionSubscriptionId) {
        this.draftState.currentDeliveryPoint.loading = true;
        this.draftState.currentDeliveryPoint.errorMessage = undefined;
    };
    DeliveryPointState.prototype.fetchDeliveryPointSuccess = function (deliverypoint) {
        this.draftState.currentDeliveryPoint.loading = false;
        this.draftState.currentDeliveryPoint.data = deliverypoint;
    };
    DeliveryPointState.prototype.fetchDeliveryPointFailure = function (errorMsg, errorDesc) {
        this.draftState.currentDeliveryPoint.loading = false;
        this.draftState.currentDeliveryPoint.errorMessage = errorMsg;
    };
    //fetch combined delivery point by its id
    DeliveryPointState.prototype.fetchCombinedDeliveryPoint = function (sectionSubscriptionId) {
        this.draftState.combinedDeliveryPoint.loading = true;
        this.draftState.combinedDeliveryPoint.data = null;
        this.draftState.combinedDeliveryPoint.errorMessage = null;
    };
    DeliveryPointState.prototype.fetchCombinedDeliveryPointSuccess = function (deliverypoint) {
        this.draftState.combinedDeliveryPoint.loading = false;
        this.draftState.combinedDeliveryPoint.errorMessage = null;
        this.draftState.combinedDeliveryPoint.data = deliverypoint;
    };
    DeliveryPointState.prototype.fetchCombinedDeliveryPointFailure = function (errorMsg) {
        this.draftState.combinedDeliveryPoint.loading = false;
        this.draftState.combinedDeliveryPoint.data = null;
        this.draftState.combinedDeliveryPoint.errorMessage = errorMsg;
    };
    //fetch delivery point list by product contract id
    DeliveryPointState.prototype.fetchDeliveryPointsList = function (productContractId) {
        this.draftState.deliveryPoints.loading = true;
        this.draftState.deliveryPoints.errorMessage = undefined;
    };
    DeliveryPointState.prototype.fetchdeliveryPointsListSuccess = function (deliveryPointsList) {
        this.draftState.deliveryPoints.loading = false;
        this.draftState.deliveryPoints.data = deliveryPointsList;
    };
    DeliveryPointState.prototype.fetchdeliveryPointsListFailure = function (errorMsg) {
        this.draftState.deliveryPoints.loading = false;
        this.draftState.deliveryPoints.errorMessage = errorMsg;
    };
    //fetch delivery point list by product contract id
    DeliveryPointState.prototype.fetchLastMeterIndex = function (sectionSubscriptionId) {
        this.draftState.meterIndex.success = null;
        this.draftState.meterIndex.loading = true;
        this.draftState.meterIndex.errorMessage = undefined;
    };
    DeliveryPointState.prototype.fetchLastMeterIndexSuccess = function (meterIndex) {
        this.draftState.meterIndex.loading = false;
        this.draftState.meterIndex.success = true;
        this.draftState.meterIndex.data = meterIndex;
        this.draftState.meterIndex.isSanitationOnly = false;
        if (!meterIndex)
            this.draftState.meterIndex.isSanitationOnly = true;
    };
    DeliveryPointState.prototype.fetchLastMeterIndexFailure = function (errorMsg) {
        this.draftState.meterIndex.success = false;
        this.draftState.meterIndex.loading = false;
        this.draftState.meterIndex.errorMessage = errorMsg;
    };
    //fetch meter infos by delivery point id
    DeliveryPointState.prototype.fetchMeterInfos = function (deliveryPointId) {
        this.draftState.meterInfo.loading = true;
        this.draftState.meterInfo.errorMessage = undefined;
    };
    DeliveryPointState.prototype.fetchMeterInfoSuccess = function (meterinfo) {
        this.draftState.meterInfo.loading = false;
        this.draftState.meterInfo.data = meterinfo;
    };
    DeliveryPointState.prototype.fetchMeterInfoFailure = function (errorMsg) {
        this.draftState.meterInfo.loading = false;
        this.draftState.meterInfo.errorMessage = errorMsg;
    };
    /**
     * @deprecated use fetchalerts
     */
    DeliveryPointState.prototype.fetchOverConsumptionAlerts = function (sectionSubscriptionId) {
        this.draftState.overConsumptionsAlerts.loading = true;
        this.draftState.overConsumptionsAlerts.errorMessage = undefined;
    };
    /**
     * @deprecated use fetchAlertsSuccess
     */
    DeliveryPointState.prototype.fetchOverConsumptionAlertsSuccess = function (overConsumptionAlerts) {
        this.draftState.overConsumptionsAlerts.loading = false;
        this.draftState.overConsumptionsAlerts.data = overConsumptionAlerts;
    };
    /**
     * @deprecated use fetchAlertsFailure
     */
    DeliveryPointState.prototype.fetchOverConsumptionAlertsFailure = function (errorMsg) {
        this.draftState.overConsumptionsAlerts.loading = false;
        this.draftState.overConsumptionsAlerts.errorMessage = errorMsg;
    };
    DeliveryPointState.prototype.fetchAlertsBase = function () {
        this.draftState.alerts.loading = true;
        this.draftState.alerts.errorMessage = undefined;
        this.draftState.alerts.success = null;
        this.draftState.alerts.data = null;
    };
    //Action fo alerts
    DeliveryPointState.prototype.fetchAlerts = function (sectionSubscriptionId) {
        this.fetchAlertsBase();
    };
    DeliveryPointState.prototype.fetchAlertsFromMobileApp = function (sectionSubscriptionId, origin) {
        this.fetchAlertsBase();
    };
    DeliveryPointState.prototype.fetchAlertsSuccess = function (alert, language) {
        this.draftState.alerts.loading = false;
        this.draftState.alerts.data = alert;
        this.draftState.alerts.orderedData = (0, buildOrderAlertsData_1.buildOrderAlertsData)(alert, language);
        this.draftState.alerts.success = true;
    };
    DeliveryPointState.prototype.fetchAlertsFailure = function (errorMsg) {
        this.draftState.alerts.loading = false;
        this.draftState.alerts.errorMessage = errorMsg;
        this.draftState.alerts.success = false;
        this.draftState.alerts.data = null;
    };
    //Send meter reading
    DeliveryPointState.prototype.sendMeterReading = function (meterReading) {
        this.draftState.sendingMeterIndex.loading = true;
        this.draftState.sendingMeterIndex.isSend = false;
        this.draftState.sendingMeterIndex.errorMessage = undefined;
    };
    DeliveryPointState.prototype.sendMeterReadingSuccess = function (meter) {
        this.draftState.sendingMeterIndex.loading = false;
        this.draftState.sendingMeterIndex.isSend = true;
    };
    DeliveryPointState.prototype.sendMeterReadingFailure = function (errorMsg, technicalErrorMessage) {
        this.draftState.sendingMeterIndex.loading = false;
        this.draftState.sendingMeterIndex.isSend = false;
        this.draftState.sendingMeterIndex.errorMessage = errorMsg;
        this.draftState.sendingMeterIndex.technicalErrorMessage =
            technicalErrorMessage;
    };
    DeliveryPointState.prototype.downloadProofDocument = function (sectionSubscriptionId) {
        this.draftState.downloadDocument.downloadLoading = true;
        this.draftState.downloadDocument.errorStatus = null;
        this.draftState.downloadDocument.loaded = false;
        this.draftState.downloadDocument.proofDocument = null;
        this.draftState.downloadDocument.downloadErrorMsg = null;
    };
    DeliveryPointState.prototype.downloadProofDocumentForMobile = function (payload) {
        this.draftState.downloadDocument.downloadLoading = true;
        this.draftState.downloadDocument.errorStatus = null;
        this.draftState.downloadDocument.loaded = false;
        this.draftState.downloadDocument.proofDocument = null;
        this.draftState.downloadDocument.downloadErrorMsg = null;
    };
    DeliveryPointState.prototype.downloadProofDocumentSuccess = function (proofDocument) {
        this.draftState.downloadDocument.downloadLoading = false;
        this.draftState.downloadDocument.loaded = true;
        this.draftState.downloadDocument.downloadErrorMsg = null;
        this.draftState.downloadDocument.proofDocument = proofDocument;
        this.draftState.downloadDocument.errorStatus = null;
    };
    DeliveryPointState.prototype.downloadInvoiceDocumentsFailure = function (errorMsg, errorStatus) {
        this.draftState.downloadDocument.downloadLoading = false;
        this.draftState.downloadDocument.downloadErrorMsg = errorMsg;
        this.draftState.downloadDocument.errorStatus = errorStatus;
        this.draftState.downloadDocument.proofDocument = null;
        this.draftState.downloadDocument.loaded = false;
    };
    DeliveryPointState.prototype.resetSendMeterReading = function () {
        this.draftState.sendingMeterIndex = exports.initialState.sendingMeterIndex;
    };
    // Update residualLeakStatus
    DeliveryPointState.prototype.updateResidualLeakStatus = function (updateResidualLeakStatusPayload) {
        this.draftState.updateResidualLeakStatus.loading = true;
        this.draftState.updateResidualLeakStatus.errorMessage = null;
        this.draftState.updateResidualLeakStatus.success = null;
    };
    DeliveryPointState.prototype.updateResidualLeakStatusFailure = function (errorMsg) {
        this.draftState.updateResidualLeakStatus.loading = false;
        this.draftState.updateResidualLeakStatus.errorMessage = errorMsg;
        this.draftState.updateResidualLeakStatus.success = false;
    };
    DeliveryPointState.prototype.updateResidualLeakStatusSuccess = function (updateResidualLeakStatusPayload) {
        if (this.draftState.alerts.data)
            this.draftState.alerts.data.isResidualLeakServiceActive =
                updateResidualLeakStatusPayload.residualLeakServiceStatus;
        this.draftState.updateResidualLeakStatus.loading = false;
        this.draftState.updateResidualLeakStatus.errorMessage = null;
        this.draftState.updateResidualLeakStatus.success = true;
    };
    // Update TranquilityStatus
    DeliveryPointState.prototype.updateTranquilityStatus = function (updateTranquilityStatusPayload) {
        this.draftState.updateTranquilityStatus.loading = true;
        this.draftState.updateTranquilityStatus.errorMessage = null;
        this.draftState.updateTranquilityStatus.success = null;
    };
    DeliveryPointState.prototype.updateTranquilityStatusFailure = function (errorMsg) {
        this.draftState.updateTranquilityStatus.loading = false;
        this.draftState.updateTranquilityStatus.errorMessage = errorMsg;
        this.draftState.updateTranquilityStatus.success = false;
    };
    DeliveryPointState.prototype.updateTranquilityStatusSuccess = function (updateTranquilityStatusPayload) {
        if (this.draftState.alerts.data)
            this.draftState.alerts.data.isTranquilityServiceActive =
                updateTranquilityStatusPayload.tranquilityServiceStatus;
        this.draftState.updateTranquilityStatus.loading = false;
        this.draftState.updateTranquilityStatus.errorMessage = null;
        this.draftState.updateTranquilityStatus.success = true;
    };
    // Update OverconsumptionThreshold
    DeliveryPointState.prototype.updateOverconsumptionThreshold = function (overconsumptionThresholdPayload) {
        this.draftState.updateOverconsumptionThreshold.loading = true;
        this.draftState.updateOverconsumptionThreshold.errorMessage = null;
        this.draftState.updateOverconsumptionThreshold.success = null;
    };
    DeliveryPointState.prototype.updateOverconsumptionThresholdFailure = function (errorMsg) {
        this.draftState.updateOverconsumptionThreshold.loading = false;
        this.draftState.updateOverconsumptionThreshold.errorMessage = errorMsg;
        this.draftState.updateOverconsumptionThreshold.success = false;
    };
    DeliveryPointState.prototype.updateOverconsumptionThresholdSuccess = function (overConsumptionThresholdPayload) {
        if (this.draftState.alerts.data) {
            this.draftState.alerts.data.overConsumptionThreshold.durationThresholdInDays =
                overConsumptionThresholdPayload.durationThresholdInDays;
            this.draftState.alerts.data.overConsumptionThreshold.volumeThresholdInL =
                overConsumptionThresholdPayload.volumeThresholdInL;
        }
        this.draftState.updateOverconsumptionThreshold.loading = false;
        this.draftState.updateOverconsumptionThreshold.errorMessage = null;
        this.draftState.updateOverconsumptionThreshold.success = true;
    };
    // get request tracking steps and their status (suivi de la demande de branchement)
    DeliveryPointState.prototype.fetchRequestTracking = function (requestId) {
        this.draftState.requestsTracking.loading = true;
        this.draftState.requestsTracking.success = false;
        this.draftState.requestsTracking.errorMsg = null;
        this.draftState.requestsTracking.data = null;
    };
    DeliveryPointState.prototype.fetchRequestTrackingSuccess = function (data) {
        this.draftState.requestsTracking.loading = false;
        this.draftState.requestsTracking.success = true;
        this.draftState.requestsTracking.errorMsg = null;
        this.draftState.requestsTracking.data = data;
    };
    DeliveryPointState.prototype.fetchRequestTrackingFailure = function (errorMsg) {
        this.draftState.requestsTracking.loading = false;
        this.draftState.requestsTracking.success = false;
        this.draftState.requestsTracking.errorMsg = errorMsg;
        this.draftState.requestsTracking.data = null;
    };
    DeliveryPointState.prototype.getClientMeterIndexEligibility = function (payload) {
        this.draftState.sendingMeterIndexEligibility.loading = true;
        this.draftState.sendingMeterIndexEligibility.errorMessage = null;
        this.draftState.sendingMeterIndexEligibility.success = false;
        this.draftState.sendingMeterIndexEligibility.sendingMeterIndexEligibility = null;
    };
    DeliveryPointState.prototype.getClientMeterIndexEligibilitySuccess = function () {
        this.draftState.sendingMeterIndexEligibility.loading = false;
        this.draftState.sendingMeterIndexEligibility.errorMessage = null;
        this.draftState.sendingMeterIndexEligibility.success = true;
        this.draftState.sendingMeterIndexEligibility.sendingMeterIndexEligibility = "success";
    };
    DeliveryPointState.prototype.getClientMeterIndexEligibilityFailure = function (errorMessage) {
        this.draftState.sendingMeterIndexEligibility.loading = false;
        this.draftState.sendingMeterIndexEligibility.errorMessage = errorMessage;
        this.draftState.sendingMeterIndexEligibility.success = false;
        this.draftState.sendingMeterIndexEligibility.sendingMeterIndexEligibility = "failure";
    };
    return DeliveryPointState;
}(immer_reducer_1.ImmerReducer));
exports.DeliveryPointState = DeliveryPointState;
exports.deliveryPointActions = (0, immer_reducer_1.createActionCreators)(DeliveryPointState);
exports.deliveryPointReducerFunction = (0, immer_reducer_1.createReducerFunction)(DeliveryPointState, exports.initialState);
